import { formatDecimalNumber } from "../../../Common/DetailsForm/Presenter/Helpers/formatDecimalNumber";
import { limitedText } from "../../../Common/DetailsForm/Presenter/Helpers/limitedText";
import type { ProductReturnRequestItemViewModel } from "../Vm/ProductReturnRequestItemViewModel";

export default function ProductReturnRequestItemDisplayFragment(props: {
  items: ProductReturnRequestItemViewModel[];
  onRemoveItem: (index: number) => void;
  onEditItem: (index: number) => void;
  onNewItem: () => void;
  isNewItemEnabled: boolean;
  onOpenDocumentSelector: () => void;
}) {
  return (
    <>
      {props.items.length > 0 && (
        <table className="table table-striped" style={{backgroundColor: "rgba(248, 249, 250, 0.8)"}}>
          <thead>
            <tr>
              <th>Poz</th>
              <th>Kod pozycji</th>
              <th>Nazwa towaru</th>
              <th>Numer katalogowy</th>
              <th className="text-center">Ilość do reklamacji</th>
              <th>Uwagi</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {props.items.map((item: ProductReturnRequestItemViewModel, index) => (
              <tr key={item.id}>
                <td className="text-end">{index + 1}</td>
                <td>
                  {
                    item.documentItem
                      ?.lineCode
                  }
                </td>
                <td>
                  {
                    item.documentItem?.productName
                  }
                </td>
                <td>
                  {
                    item.documentItem?.catalogNumber
                  }
                </td>
                <td className="text-end">
                  {formatDecimalNumber(
                    // biome-ignore lint/style/noNonNullAssertion: at this point the amount should have been filled in, so it's safe to use non-null assertion here.
                    item.amount!,
                    4,
                  )}
                </td>
                <td>
                  {limitedText(
                    item.comments || "",
                    30,
                  )}
                </td>
                <td>
                  {/** biome-ignore lint/a11y/useValidAnchor: button link causes layout problems */}
                  {/** biome-ignore lint/a11y/useSemanticElements: button link causes layout problems */}
                  <a
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      props.onRemoveItem(index);
                    }}
                    href="#"
                    role="button"
                    className="link-danger me-3 small text-decoration-none"
                    title="Kliknij, aby usunąć tą pozycję z formularza."
                  >
                    <i className="bi bi-trash3 ps-2"></i> Usuń
                  </a>
                  {/** biome-ignore lint/a11y/useValidAnchor: button link causes layout problems */}
                  {/** biome-ignore lint/a11y/useSemanticElements: button link causes layout problems  */}
                  <a
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      props.onEditItem(index);
                    }}
                    href="#"
                    role="button"
                    className="link-primary small text-decoration-none"
                    title="Kliknij, aby zmienić zawartość tej pozycji."
                  >
                    <i className="bi bi-pencil-square"></i> Edytuj
                  </a>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {props.items.length === 0 && (
        <div className="row mb-3">
          <div className="col-sm-12">
            <div
              className="alert alert-primary d-flex align-items-center"
              role="alert"
            >
              <div className="flex-shrink-0 ms-3 me-4">
                <i className="bi bi-lightbulb"></i>
              </div>
              <div>
                <b>Brak pozycji</b>
                <br />
                Przed wysłaniem zgłoszenia musisz dodać co najmniej jedną
                pozycję, której dotyczy zgłoszenie.
                {!props.isNewItemEnabled && (
                  <>
                    <br />
                    <b>Dokument nie został wybrany</b>
                    <br />
                    Aby dodać pozycję, musisz najpierw{" "}
                    {/** biome-ignore lint/a11y/useValidAnchor: button link causes layout problems */}
                    {/** biome-ignore lint/a11y/useSemanticElements: button link causes layout problems */}
                    <a
                      role="button"
                      href="#"
                      onClick={(
                        e: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
                      ) => {
                        e.preventDefault();
                        props.onOpenDocumentSelector();
                      }}
                      className="alert-link"
                    >
                      <b>wybrać dokument sprzedaży</b>.
                    </a>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="row mb-3">
        <div className="col-sm-12">
          <button
            type="button"
            onClick={() => {
              props.onNewItem();
            }}
            className={`btn btn-success py-1 ps-4 pe-5`}
            disabled={!props.isNewItemEnabled}
          >
            <i className="bi bi-plus-circle ps-2 me-2"></i> Dodaj pozycję
          </button>
        </div>
      </div>
    </>
  );
}
